import reducer from './reducers';

export { default as versionSelectors } from './selectors';
export { default as versionOperations } from './operations';
export { default as versionTypes } from './types';

export default reducer;
